"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editorialPageMockData = exports.editorialPageInvalidData = exports.editorialPage = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
var _faqMock = require("./faqMock");
var _headerArea = require("./headerArea");
var _linkListMock = require("./linkListMock");
var _mockBannerComponentProps = require("./mockBannerComponentProps");
var _mockedBenefits = require("./mockedBenefits");
var _mockedFiftyBanner = require("./mockedFiftyBanner");
var _mockedListCarousel = require("./mockedListCarousel");
var _tableMock = require("./tableMock");
var _testimonialMock = require("./testimonialMock");
const editorialPage = exports.editorialPage = {
  editorialPage: {
    pageId: 'someId',
    contentItems: [{
      __typename: 'EditorialHeader',
      id: 'someId',
      headline: 'Some Editorial Page',
      text: 'Some text',
      backgroundStorybookColor: _editorialFetching.StorybookColor.CommonWhite,
      headlineStorybookColor: _editorialFetching.StorybookColor.TextPrimary
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.Quote,
      id: 'someQuote',
      modules: [{
        backgroundStorybookColor: _editorialFetching.StorybookColor.CommonWhite,
        backgroundType: _editorialFetching.BackgroundType.Color,
        content: {
          title: 'Some Quote title',
          showReadMoreOption: false,
          titleStorybookColor: _editorialFetching.StorybookColor.Grey900,
          titleColor: _editorialFetching.EditorialBannerTitleColorEnum.Black,
          titleSize: _editorialFetching.EditorialBannerTitleSizeEnum.H5,
          horizontalAlignment: _editorialFetching.HorizontalContentAlignment.Undefined
        }
      }]
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.ParagraphText,
      id: 'someParagraph',
      modules: [{
        backgroundType: _editorialFetching.BackgroundType.Color,
        backgroundStorybookColor: _editorialFetching.StorybookColor.CommonWhite,
        content: {
          title: 'Some Paragraph title',
          textCollection: [{
            text: 'Some Paragraph text collection'
          }],
          titleColor: _editorialFetching.EditorialBannerTitleColorEnum.Black,
          titleStorybookColor: _editorialFetching.StorybookColor.Grey900,
          showReadMoreOption: false,
          titleSize: _editorialFetching.EditorialBannerTitleSizeEnum.H5,
          horizontalAlignment: _editorialFetching.HorizontalContentAlignment.Undefined
        }
      }]
    }]
  }
};
const editorialPageInvalidData = exports.editorialPageInvalidData = {
  editorialPage: {
    __typename: 'EditorialPage',
    pageId: 'someId',
    contentItems: [{
      __typename: 'EditorialHeader',
      id: 'someId',
      headline: 'This is Editorial page with errors',
      backgroundStorybookColor: _editorialFetching.StorybookColor.CommonWhite,
      headlineStorybookColor: _editorialFetching.StorybookColor.TextPrimary
    }, {}, {
      __typename: 'EditorialHeader',
      id: 'someId2',
      backgroundStorybookColor: _editorialFetching.StorybookColor.CommonWhite,
      headlineStorybookColor: _editorialFetching.StorybookColor.TextPrimary
    }, {
      __typename: 'EditorialProductBoxCarousel',
      products: []
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.OneMediaCenterBottomText,
      id: 'someId5',
      modules: []
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayLeftText,
      id: 'someId6',
      modules: []
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayRightText,
      id: 'someId7',
      modules: []
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.FourMedia,
      id: 'someId8'
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.Headline,
      id: 'someId9',
      modules: [{
        backgroundType: _editorialFetching.BackgroundType.Color,
        backgroundStorybookColor: _editorialFetching.StorybookColor.CommonWhite
      }]
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.OneMediaParagraphText,
      id: 'someId10'
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.ParagraphText,
      id: 'someId11'
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.Quote,
      id: 'someId12',
      modules: [{
        backgroundType: _editorialFetching.BackgroundType.Color,
        backgroundStorybookColor: _editorialFetching.StorybookColor.CommonWhite
      }]
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.ThreeMediaRightBottomText,
      id: 'someId13',
      modules: []
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.TwoMedia,
      id: 'someId14'
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.TwoMediaRightTopText,
      id: 'someId15'
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.Video,
      id: 'someId16'
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.Video,
      id: 'someId17',
      modules: [{
        backgroundType: _editorialFetching.BackgroundType.Color,
        backgroundStorybookColor: _editorialFetching.StorybookColor.CommonWhite,
        content: {
          title: 'someTitle',
          showReadMoreOption: false,
          titleStorybookColor: _editorialFetching.StorybookColor.Grey900,
          titleColor: _editorialFetching.EditorialBannerTitleColorEnum.Black,
          titleSize: _editorialFetching.EditorialBannerTitleSizeEnum.H5,
          horizontalAlignment: _editorialFetching.HorizontalContentAlignment.Undefined
        }
      }]
    }, {
      __typename: 'EditorialBanner',
      layout: _editorialFetching.EditorialBannerLayoutEnum.Video,
      id: 'someId18',
      modules: [{
        backgroundVideo: {
          autoplayOnScroll: true,
          id: 'https://media-uat-cdn.oriflame.com/productVideo?externalMediaId=product-management-media%2fProducts%2f12760%2f12760_6.mp4&MediaId=16512000&Version=3#t=0.001'
        },
        backgroundType: _editorialFetching.BackgroundType.Video,
        backgroundStorybookColor: _editorialFetching.StorybookColor.CommonWhite,
        content: {
          title: 'someTitle',
          showReadMoreOption: false,
          titleStorybookColor: _editorialFetching.StorybookColor.Grey900,
          titleColor: _editorialFetching.EditorialBannerTitleColorEnum.Black,
          titleSize: _editorialFetching.EditorialBannerTitleSizeEnum.H5,
          horizontalAlignment: _editorialFetching.HorizontalContentAlignment.Undefined
        }
      }]
    }]
  }
};
const editorialPageMockData = exports.editorialPageMockData = {
  breadcrumbs: _headerArea.headerAreaMock.breadcrumbs,
  productBoxConfiguration: {},
  data: {
    application: {
      editorialLandingPage: {
        landingPageId: 'someId',
        themeItems: _editorialFetching.categories
      },
      editorialPage: {
        pageId: 'someId',
        contentItems: [_headerArea.headerAreaMock.header, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.OneMediaCenterBottomText).banner.layout,
          id: '0',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.OneMediaCenterBottomText).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayLeftText).banner.layout,
          id: '1',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayLeftText).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayRightText).banner.layout,
          id: '2',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayRightText).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.FourMedia).banner.layout,
          id: '3',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.FourMedia).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.Headline).banner.layout,
          id: '4',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.Headline).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.OneMediaParagraphText).banner.layout,
          id: '5',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.OneMediaParagraphText).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.ParagraphText).banner.layout,
          id: '6',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.ParagraphText).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.Quote).banner.layout,
          id: '7',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.Quote).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.ThreeMediaRightBottomText).banner.layout,
          id: '8',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.ThreeMediaRightBottomText).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.TwoMedia).banner.layout,
          id: '9',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.TwoMedia).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.TwoMediaRightTopText).banner.layout,
          id: '10',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.TwoMediaRightTopText).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.Video).banner.layout,
          id: '11',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.Video).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.VerticalVideo).banner.layout,
          id: '12',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.VerticalVideo).banner.modules
        }, {
          __typename: 'EditorialBanner',
          layout: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.Quote).banner.layout,
          id: '13',
          modules: (0, _mockBannerComponentProps.mockBannerComponentProps)(_editorialFetching.EditorialBannerLayoutEnum.Quote).banner.modules
        },
        // @ts-expect-error -- For testing purposes.
        {
          ..._mockedFiftyBanner.mockedFiftyBanner,
          id: '14'
        }, {
          ..._testimonialMock.testimonialMock,
          id: '15'
        }, {
          ..._faqMock.faqMock,
          id: '16'
        }, {
          ..._linkListMock.linkListMock,
          id: '17'
        }, {
          ..._mockedListCarousel.mockedListCarousel,
          id: '18'
        }, {
          ..._mockedBenefits.mockedThreeBenefits,
          id: '19'
        }, {
          ..._mockedBenefits.mockedSixBenefits,
          id: '20'
        }, {
          ..._tableMock.tableMock,
          id: '21'
        }, ..._editorialFetching.articles]
      }
    }
  }
};
